import { render, staticRenderFns } from "./CashDeskIndex.vue?vue&type=template&id=687fd6d8&scoped=true"
import script from "./CashDeskIndex.vue?vue&type=script&lang=js"
export * from "./CashDeskIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687fd6d8",
  null
  
)

export default component.exports